import { Cookies } from 'react-cookie';

import {
  clear as localStorageClear,
  get as localStorageGet,
  remove as localStorageRemove,
  set as localStorageSet,
} from 'local-storage';
import { get as lodashGet } from 'lodash';
import { LoggerStatusEnum, sendLog } from 'ui-model';

function isLocalStorageAvailable() {
  try {
    const x = '__storage_test__';
    const isAvailable = localStorageSet(x, x);
    localStorageRemove(x);
    return isAvailable;
  } catch (e) {
    sendLog(
      'storageClient - line 15',
      {
        error: lodashGet(e, 'message', 'no error message'),
      },
      LoggerStatusEnum.error,
    );
    return false;
  }
}

const useLocalStorage = isLocalStorageAvailable();
const cookies = new Cookies();

function get(key: string) {
  return useLocalStorage ? localStorageGet(key) : cookies.get(key);
}

function set(key: string, value: any) {
  if (useLocalStorage) {
    return localStorageSet(key, value);
  }
  return cookies.set(key, value);
}

function remove(key: string) {
  if (useLocalStorage) {
    return localStorageRemove(key);
  }
  return cookies.remove(key);
}

function clear() {
  if (useLocalStorage) {
    return localStorageClear();
  }
}

export default {
  get,
  set,
  remove,
  clear,
};
